var Enable_pincode = true;

if(Enable_pincode){

    const pin_regex = /^[1-9][0-9]{5}$/;

    $('#pincode_1').keyup(function(){
        // Only numbers allowed
        if (/\D/g.test(this.value)) {
            this.value = this.value.replace(/\D/g,'');
        }

        var val = this.value.trim();

        if(val.length < 6 || !pin_regex.test(val)){
            $('#responsemessage').text('Please enter valid Pincode')
                .removeClass('success').addClass('error');
            return;
        }

        // API Call
        pincodeValidation(val);
    });

    function pincodeValidation(pincode) {
        const apiUrl = `https://shopify.wforwoman.com/pincodes/shiprocket/service/${pincode}`;

        $.ajax({
            url: apiUrl,
            method: "GET",
            dataType: "json",
            success: function (response) {
                if (
                    response.success &&
                    response.data &&
                    response.data.data &&
                    Array.isArray(response.data.data.available_courier_companies) &&
                    response.data.data.available_courier_companies.length > 0
                ) {
                    let delivery_day = 2;

                    localStorage.setItem('ExistPincode', pincode);
                    localStorage.setItem('DeliveryDays', delivery_day);

                    getDelivery(delivery_day);
                } else {
                    showError("Delivery pincode not serviceable.");
                }
            },
            error: function () {
                showError("Error fetching delivery info. Please try again.");
            }
        });
    }

    function showError(message) {
        $('#responsemessage').html(`<span class="errorMsg">${message}</span>`)
            .removeClass('success').addClass('error');
    }

    function getDelivery(delivery_day){
        var next_dt = new Date();
        next_dt.setDate(next_dt.getDate() + delivery_day);

        var monthNames = [ "January", "February", "March", "April", "May", "June", 
                         "July", "August", "September", "October", "November", "December" ];
        
        var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        var month_Name = monthNames[next_dt.getMonth()];
        var date_Name  = next_dt.getDate();
        var day_Name   = dayNames[next_dt.getDay()];

        $('#responsemessage').html(`
            <span class="span2">
                <u>FREE delivery: </u>
                <b>${day_Name}, ${month_Name} ${date_Name}</b>
            </span>
            <span class="span1">Free delivery</span>
        `).removeClass('error').addClass('success');
    }

    // Page Load - Existing Pincode & Delivery Date
    var Existing_pin = localStorage.getItem('ExistPincode');
    var Existing_days = parseInt(localStorage.getItem('DeliveryDays'));

    if(Existing_pin) {
        $('#pincode_1').val(Existing_pin);
    }
    if (!isNaN(Existing_days)) {
        getDelivery(Existing_days);
    }
}